// extracted by mini-css-extract-plugin
module.exports = {"container":"openaccount_container__Io5Il","heading":"openaccount_heading__tJosQ","textsection":"openaccount_textsection__LpDZx","btn":"openaccount_btn__1Tc2F"};